type Listener = (error: Error) => void;

const listeners: Listener[] = [];

export const errorEmitter = {
  emit(error: Error) {
    listeners.forEach((l) => l(error));
  },
  subscribe(listener: Listener) {
    listeners.push(listener);
    return () => {
      const idx = listeners.indexOf(listener);
      if (idx > -1) listeners.splice(idx, 1);
    };
  },
};
